import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange } from '@angular/core';

@Component({
    selector: 'lf-form-messages',
    styleUrls: ['./form-messages.scss'],
    templateUrl: './form-messages.component.html',
})
export class FormMessagesComponent implements OnChanges, OnInit
{
    // Delay in milliseconds before auto-hiding message. Set to 0 to disable.
    @Input()
    public hideDelay: number = 4000;

    // Type of message styling to use.
    // 'success', 'failure', 'info'
    @Input()
    public type: string = 'success';

    // Message to display.
    @Input()
    public message: string = null;
    @Output()
    public messageChange: EventEmitter<string> = new EventEmitter<string>();

    // Whether or not the message is currently visible.
    public show: boolean = false;

    ngOnInit() {
        if (this.message) {
            this.showMessage();
        } else {
            this.show = false;
        }
    }

    ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
        if (changes.hasOwnProperty('message') && !changes['message'].isFirstChange()) {
            if (changes['message'].currentValue) {
                this.showMessage();
            } else {
                this.show = false;
            }
        }
    }

    public showMessage() {
        this.show = true;
        if (this.hideDelay > 0) {
            const self = this;
            setTimeout(function () {
                self.show = false;
                self.message = '';
                self.messageChange.emit(self.message);
            }, this.hideDelay);
        }
    }
}
